export default __webpack_public_path__ + "static/media/howls-moving-castle.8900aeba.jpg";